import { call, put, takeEvery } from "redux-saga/effects"
import { GET_SEASON } from "./actionTypes"
import { getSeasonAPI, getSeasonListAPI } from "helpers/season_helper"

import { getSeasonSuccess, getSeasonError } from "./actions"
import debounce from "debounce-promise"

const debouncegetSeasonAPI = debounce(getSeasonAPI, 1000)
const debouncegetSeasonListAPI = debounce(getSeasonListAPI, 1000)

function* fetchSeason(args) {
  let params = args.payload
  yield put(getSeasonSuccess({ status: "process", data: {} }))
  try {
    if (args.isList) {
      let { data } = yield call(debouncegetSeasonListAPI, params)
      yield put(getSeasonSuccess({ status: "success", data }))
    } else {
      let { data } = yield call(debouncegetSeasonAPI, params)
      yield put(getSeasonSuccess({ status: "success", data }))
    }
  } catch (error) {
    yield put(getSeasonError(error?.response))
  }
}

function* fabricSaga() {
  yield takeEvery(GET_SEASON, fetchSeason)
}

export default fabricSaga
